import _defineProperty from "/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { providers } from 'ethers';
import { b as defaultInfuraApiKey } from '../../../dist/rpcs-6e1b1718.esm.js';

function infuraProvider() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$apiKey = _ref.apiKey,
      apiKey = _ref$apiKey === void 0 ? defaultInfuraApiKey : _ref$apiKey,
      priority = _ref.priority,
      stallTimeout = _ref.stallTimeout,
      weight = _ref.weight;

  return function (chain) {
    if (!chain.rpcUrls.infura) return null;
    return {
      chain: _objectSpread(_objectSpread({}, chain), {}, {
        rpcUrls: _objectSpread(_objectSpread({}, chain.rpcUrls), {}, {
          default: "".concat(chain.rpcUrls.infura, "/").concat(apiKey)
        })
      }),
      provider: function provider() {
        var provider = new providers.InfuraProvider(chain.id, apiKey);
        return Object.assign(provider, {
          priority: priority,
          stallTimeout: stallTimeout,
          weight: weight
        });
      },
      webSocketProvider: function webSocketProvider() {
        return new providers.InfuraWebSocketProvider(chain.id, apiKey);
      }
    };
  };
}

export { infuraProvider };